import * as React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import CircularProgressbar from "../../common/CircularProgressbar";
import * as Tools from "../../../helpers/Tools";
import TileLoader from '../../common/tileLoader';
import MiniSpinner from "../../common/MiniSpinner";
import { NOT_STARTED, INCOMPLETE, COMPLETE, NOT_ENROLLED } from '../../../constants/textConstants';
import ErrorLoadingTile from "../../common/errorLoadingTile";
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { logUI } from '../../../api/andyliticsApi';
import BackdropWrapper from "../../common/BackdropWrapper";

const THRIVE_URL = "https://bswh.livehealthyignite.com/users/sign_in";

class Thrive365Tile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            isIconSrcValid: props && props.bffDashboardData && props.bffDashboardData.data && props.bffDashboardData.data.xealthWellnessMessage && props.bffDashboardData.data.xealthWellnessMessage.dcjIconWeb ? true : false
        }
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Thrive365Tile.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    //getJourneyEnrolledStatus = () => {
    //    let wellnessDCJList = null;
    //    let userEnrolledInJourney = null;
    //    let wellnessDCJListForCurrentPatient = null;
    //    const { bffDashboardData, currentUser } = this.props;
    //    if (currentUser && currentUser.epi && bffDashboardData && bffDashboardData.data && bffDashboardData.data.dcjStatus && bffDashboardData.data.dcjStatus.wellnessDCJList) {
    //        wellnessDCJList = bffDashboardData.data.dcjStatus.wellnessDCJList;
    //        if (wellnessDCJList && wellnessDCJList.length > 0) {
    //            wellnessDCJListForCurrentPatient = wellnessDCJList.filter(el => el.patient_id === currentUser.epi);
    //            userEnrolledInJourney = wellnessDCJListForCurrentPatient && wellnessDCJListForCurrentPatient.length > 0;
    //            //userEnrolledInJourney = wellnessDCJListForCurrentPatient && wellnessDCJListForCurrentPatient.find(el => el.complete || el.terminated);                
    //        }
    //    }
    //    return userEnrolledInJourney ? { isJourneyEnrolled: true } : { isJourneyEnrolled: false };

    //}

    toggleModal = () => {
        this.setState({
            openModal: !this.state.openModal
        })
    }
    onImageLoad = () => {
        const { isIconSrcValid } = this.state;
        if (!isIconSrcValid) {
            this.setState({ isIconSrcValid: true });
        }
    }

    onImageError = () => {
        const { isIconSrcValid } = this.state;
        if (isIconSrcValid)
            this.setState({ isIconSrcValid: false });
    }
    addLogger = (surveyStatus) => {
        surveyStatus === NOT_STARTED ? logUI("MBHWeb.UI.Thrive365Tile.GetStartedCTA", new Date(), Tools.getURLPath()) :
            logUI("MBHWeb.UI.Thrive365Tile.FinishAssessmentCTA", new Date(), Tools.getURLPath());
    }
    updateThriveTooltipPreference = () => {
        const { doUpdateThriveTooltipPreference } = this.props;
        if (doUpdateThriveTooltipPreference) {
            doUpdateThriveTooltipPreference();
        }
        logUI("MBHWeb.UI.Thrive365Tile.ToolTip.Clicked", new Date(), Tools.getURLPath());        
    }

    render() {
        const { openModal, isIconSrcValid } = this.state;
        const { isJourneyEnrolled } = { isJourneyEnrolled: false };// this.getJourneyEnrolledStatus();
        const { thrive, cardPending, cardError, thriveData, serverData, bffDashboardData, isBffWaiting,showThriveTooltip, hasSWNTMembership, hasSWHPMembership } = this.props;
        const { xealthWellnessMessage } = bffDashboardData && bffDashboardData.data ? bffDashboardData.data : {};
        let message = xealthWellnessMessage ? xealthWellnessMessage : {};
        const { Content = "", Subject = "", From = "", dcjIconWeb = "", dcjInboxId, dcjConversationId } = message;
        const isCovidMsg = From && From.toLowerCase().indexOf("covid") !== -1 ? true : false;
        const thriveMainUrl = THRIVE_URL; //thrive && thrive.thriveMainUrl ? thrive.thriveMainUrl : "";
        const logActivity = () => {
            logToAndylitics('MBHWeb.Thrive365tile.VisitThrive.Redirect', new Date(), thriveMainUrl);
        };
        const defaultScoreColor = "#008fbe";       
        const { surveyStatus, overallScore } = thriveData || {};
        const thriveTooltipInfo = hasSWHPMembership && hasSWNTMembership ? 'Our Thrive365 program is available for all employees and their families. Employees enrolled in a Baylor Scott & White Health medical plan will need to meet specific wellness requirements.'
            : hasSWNTMembership ? 'Our Thrive365 program is available for all employees and their families. Discover wellness resources, such as articles, webinars, programs, challenges and more.'
                : '';
                       
        //const enableCustomDcjInbox = serverData && serverData.enableCustomDcjInbox ? serverData.enableCustomDcjInbox : false;
        return cardPending ? <TileLoader tilename={"BSWH EMPLOYEE WELL-BEING"} tileclass={"thrive365-tile"} /> :
            cardError ? <ErrorLoadingTile error="true" tileclass={"thrive365-tile"} tilename={"BSWH EMPLOYEE WELL-BEING"} /> :
                <React.Fragment>
                    <BackdropWrapper
                        id="showPaperlessBillingTooltip"
                        onClickBackdrop={this.updateThriveTooltipPreference}
                        toolTipInfo={thriveTooltipInfo}
                        okBtnText="OKAY"
                        scrollIntoView
                        showTooltip={showThriveTooltip}
                        wrapperClass={hasSWHPMembership && hasSWNTMembership ? `thrive365-tile hasSWHPandSWNT` :`thrive365-tile hasSWNT`}>
                        <div className="card thrive365-tile">
                            <div className="due-date-feature">{`DUE ${serverData.wellnessDueDate}`}</div><div className="due-date-feature-after"></div>
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card-heading">
                                            <span className="tooltip-link icon-question" onClick={this.toggleModal}></span>
                                            <div className="thrive365-tile__heading">THRIVE365</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row tiles-wrapper">
                                    {(surveyStatus === NOT_STARTED || surveyStatus === INCOMPLETE) &&
                                        <>
                                            <div className="col-lg-8 col-md-12 col-sm-12">
                                                <div className="thrive365-tile__sub-heading-wellBeing">Well-being Assessment</div>
                                                <div className="thrive365-tile__description">Check in on your health to understand your overall Well-being.</div>
                                            </div>
                                            <div className="col-lg-4 col-md-12 col-sm-12">
                                                <button className="btn btn-primary assessment-action" onClick={() => { this.props.history.push("/WellnessAssessment"); this.addLogger(surveyStatus); }}>{surveyStatus === NOT_STARTED ? "GET STARTED" : "FINISH ASSESSMENT"}</button>
                                            </div>
                                        </>
                                    }
                                    {(surveyStatus === COMPLETE || surveyStatus === NOT_ENROLLED) &&
                                        <>
                                            <div className="col-xl-4 col-md-6 col-12 inner-tile">
                                                <div>
                                                <CircularProgressbar percentage={overallScore} overallScoreColor={defaultScoreColor} showText="Overall" rotation={0.00}/>
                                                    <div className="thrive365-tile__sub-heading">Overall Score</div>
                                                    <div className="thrive365-tile__description">Check in on your health to understand your overall Well-being.</div>
                                                </div>
                                                <div className="thrive365-tile__view-all">
                                                    <Link className="card-link view-dashboard" to={{ pathname: '/wellbeingDashboard' }} onClick={() => logUI("MBHWeb.UI.Thrive365Tile.WellBeingDashboardClicked", new Date(), Tools.getURLPath())}>VIEW DASHBOARD</Link>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-6 col-12 thrive-activities">
                                                <div>
                                                    <div className="thrive-activities__heading">Thrive Activities</div>
                                                    <div className="thrive-activities__bitmap"></div>
                                                    <div className="thrive365-tile__description">View your current point total and continue to earn more.</div>
                                                </div>
                                                <div className="thrive365-tile__view-all">
                                                    <a className="card-link" href={thriveMainUrl} target="_blank" onClick={() => logActivity()}>
                                                        EARN POINTS
                                                </a>
                                                </div>
                                            </div>
                                            <div className="col-xl-5 col-12 inner-tile">
                                                {(surveyStatus === COMPLETE && xealthWellnessMessage && Content && !isBffWaiting && isJourneyEnrolled) ?

                                                    <>
                                                        <div>
                                                            <div className="icon-message">
                                                                {isIconSrcValid ?
                                                                    <img
                                                                        src={dcjIconWeb}
                                                                        alt="Care Coach Icon"
                                                                        onLoad={() => this.onImageLoad()}
                                                                        onError={() => this.onImageError()}
                                                                    />
                                                                    : <span className={`${isCovidMsg ? "svg-dcj-covid" : "svg-dcj-default"}`} />
                                                                }
                                                            </div>


                                                            <div className="thrive365-tile__sub-heading message-heading"><span className="message-subject">{Subject}</span><span className="text-uppercase card-label">{Tools.dateStringFormat(xealthWellnessMessage.Date, 'MMM D')}</span></div>


                                                        {/*<Link className="thrive365-tile__fill-out truncate thrive365-tile__description" to={enableCustomDcjInbox ? { pathname: `/wellbeingmessage/${dcjInboxId}/${dcjConversationId}` } : { pathname: '/wellbeingmessage' }} onClick={() => logUI("MBHWeb.UI.Thrive365Tile.MessageClicked", new Date(), Tools.getURLPath())}>{Content}</Link>*/}
                                                        </div>
                                                        {/*<div className="see-all">
                                                            <Link className="card-link" to={enableCustomDcjInbox ? { pathname: `/wellbeinginbox/${dcjInboxId}` } : { pathname: `/wellbeinginbox` }} onClick={() => logUI("MBHWeb.UI.Thrive365Tile.SeeALLClicked", new Date(), Tools.getURLPath())}>SEE ALL</Link>
                                                        </div>*/}
                                                    </>
                                                    :
                                                    <>
                                                        {(surveyStatus === COMPLETE && isBffWaiting) &&
                                                            <div className="col-12 text-center">
                                                                <MiniSpinner />
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                {surveyStatus === COMPLETE && !isJourneyEnrolled && !isBffWaiting &&
                                                    <>
                                                        <div>
                                                            <div className="col-12">
                                                        <img className="group-image"
                                                            src="images/group-24.svg"
                                                            alt="group icon" />
                                                                <div className="thrive365-tile__sub-heading">Well-being Journey</div>

                                                            </div>
                                                            <div className="col-12">
                                                                <div className="thrive365-tile__description thrive365-tile__inline-with-header">Start a journey to improve your Well-being.</div>
                                                            </div>
                                                        </div>
                                                        <div className="start-journey-link">
                                                            <Link className="thrive365-tile__inline-with-header card-link" to={{ pathname: '/wellbeingJourney' }} onClick={() => logUI("MBHWeb.UI.Thrive365Tile.StartAJourneyCTA", new Date(), Tools.getURLPath())}>START A JOURNEY</Link>
                                                        </div>
                                                    </>
                                                }
                                                </div>
                                   
                                        </>
                                    }
                                </div>
                            </div>
                    
                            <Modal className="info-modal thrive365-tile-modal" isOpen={openModal} toggle={this.toggleModal} centered>
                                <ModalBody>
                                    <div className="row">
                                        <div className="col-12">
                                            <p>Complete your Well-being Assessment and earn 365 points by <span className="earn-points-due-date">{Tools.dateStringFormat(serverData.wellnessDueDate, 'MMMM DD, YYYY')}</span> to avoid a $40 per pay period surcharge. Earn points by completing a Preventive Care Exam, talking with a wellness coach, or completing culture activities</p>
                                        </div>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <div className="row">
                                        <div className="col-6 text-center">
                                            {serverData && serverData.wellnessFAQURL && <a className="btn btn-text sub-link" href={serverData.wellnessFAQURL} target="_blank">VIEW FAQS</a>}
                                        </div>
                                        <div className="col-6 text-center">
                                            <button className="btn btn-primary" onClick={this.toggleModal}>OKAY</button>
                                        </div>
                                    </div>
                                </ModalFooter>
                            </Modal>
                        </div>
                    </BackdropWrapper>
                </React.Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        cardPending: state.thrive.cardPending,
        cardSuccess: state.thrive.cardSuccess,
        cardError: state.thrive.error,
        thrive: state.header.thrive,
        thriveData: state.thrive.card,
        userToken: state.domain.t,
        serverData: state.session.serverData,
        bffDashboardData: state.dashboard.bffDashboardData,
        currentUser: state.header && state.memberships.currentUser ? state.memberships.currentUser : {},
        isBffWaiting: state.dashboard.bffDashboardData ? state.dashboard.bffDashboardData.isWaiting : false,

    };
};

export default withRouter(connect(mapStateToProps, null)(Thrive365Tile));